import { Controller } from 'stimulus'

export default class extends Controller {

  static targets = [ 'main', 'sub', 'container' ]

  refresh = () => {
    if (this.mainTarget.value == 'closed' && this.subTarget.value == 'Lost') {
      this.containerTarget.classList.remove('dn')
    } else {
      this.containerTarget.classList.add('dn')
    }
  }

  load() {
    this.refresh()
    $(this.subTarget).on('change', this.refresh)
  }
}

